import React from "react";
import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()(theme => ({
    box: {
        position: "relative",
        display: "inline-block",
        whiteSpace: "nowrap",
        lineHeight: 1,
        letterSpacing: "0.08em",
        verticalAlign: "middle",
    },
    empty: {
        color: theme.palette.mode === "light" ? "#dcdad2" : "#3a3a37",
    },
    filled: {
        position: "absolute",
        top: 0,
        left: 0,
        overflow: "hidden",
        whiteSpace: "nowrap",
        color: "#eda100",
    },
}));

const RatingStars = ({ value, scale = 3, size = 16, className }) => {
    const { classes, cx } = useStyles();
    const n = Number(value);
    const safe = Number.isFinite(n) ? Math.max(0, Math.min(scale, n)) : 0;
    const pct = scale > 0 ? (safe / scale) * 100 : 0;
    const stars = "★".repeat(Math.max(0, Math.round(scale)));

    return (
        <span
            className={cx(classes.box, className)}
            style={{ fontSize: size }}
            role="img"
            aria-label={`${safe} / ${scale}`}
            title={`${safe} / ${scale}`}
        >
            <span className={classes.empty}>{stars}</span>
            <span className={classes.filled} style={{ width: `${pct}%` }} aria-hidden="true">
                {stars}
            </span>
        </span>
    );
};

export default RatingStars;
